document.addEventListener("DOMContentLoaded", () => {
    function checkProductsLoaded() {
        if (window.AGC_ProductArray && window.AGC_ProductArray.length > 0) {
            console.log("Collection products loaded:", window.AGC_ProductArray);
            document.dispatchEvent(new CustomEvent("AGCCollectionReady"));
            return;
        }
        setTimeout(checkProductsLoaded, 200);
    }

    checkProductsLoaded();
});